import React from 'react';

interface StateCellProps {
    text: string;
    stateColor: string;
    textColor?: string;
    style?: React.CSSProperties;
    showDot?: boolean;
}

const StateCell: React.FC<StateCellProps> = React.memo(({ text, stateColor, textColor, style, showDot = true }) => {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
            }}
        >
            <div
                style={{
                    borderColor: stateColor,
                    borderWidth: 2,
                    borderStyle: 'solid',
                    borderRadius: 15,
                    paddingLeft: 15,
                    paddingRight: 15,
                    overflow: 'hidden',
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    ...style,
                }}
            >
                <div
                    style={{
                        position: 'absolute',
                        inset: 0,
                        backgroundColor: stateColor,
                        opacity: 0.3,
                        zIndex: 0,
                    }}
                />
                <div
                    style={{
                        position: 'relative',
                        zIndex: 1,
                        color: textColor,
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        gap: 10,
                    }}
                >
                    {showDot && (
                        <div
                            style={{
                                backgroundColor: stateColor,
                                borderRadius: 20,
                                width: 8,
                                height: 8,
                            }}
                        />
                    )}
                    {text}
                </div>
            </div>
        </div>
    );
});

export default StateCell;
